import { Model, hasMany } from 'miragejs'

export default Model.extend({
  partnerContactDetails: hasMany(),
  schoolPartners: hasMany(),
})
